(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pictomini-friends"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (root = document) => root.querySelectorAll('.pv-friends').forEach((gallery) => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const rail = gallery.querySelector('.pv-friends__rail');
      const prev = gallery.querySelector('[data-friends-prev]');
      const next = gallery.querySelector('[data-friends-next]');
      gallery.querySelector('[data-friends-controls]').hidden = false;
      const sync = () => { prev.disabled = rail.scrollLeft < 2; next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2; };
      [prev, next].forEach((button, index) => button.addEventListener('click', () => rail.scrollBy({left: (index ? 1 : -1) * (rail.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'})));
      rail.addEventListener('scroll', sync, {passive: true});
      new ResizeObserver(sync).observe(rail);
      sync();
    });
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pictomini-hybrid-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const openDialogs = new Set();
    let previousOverflow = '';
    const lockScroll = (dialog) => {
      if (openDialogs.size === 0) previousOverflow = document.body.style.overflow;
      openDialogs.add(dialog);
      document.body.style.overflow = 'hidden';
    };
    const releaseScroll = (dialog) => {
      if (openDialogs.delete(dialog) && openDialogs.size === 0) document.body.style.overflow = previousOverflow;
    };
    const initialize = (root = document) => root.querySelectorAll('[data-hybrid-gallery]:not([data-gallery-initialized])').forEach((gallery) => {
      gallery.dataset.galleryInitialized = 'true';
      const track = gallery.querySelector('[data-gallery-track]');
      const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-gallery-target]')];
      const dialog = gallery.querySelector('[data-gallery-dialog]');
      const find = (s) => gallery.querySelector(s);
      const findDialog = (s) => dialog.querySelector(s);
      // Painted previews hide the original gallery. Keep its modal outside that
      // subtree, while retaining the owning builder's theme variable inheritance.
      const dialogHost = gallery.closest('.pv-builder') || gallery.closest('.pv-shell') || document.body;
      dialogHost.append(dialog);
      let current = 0;
      let dialogIndex = 0;
      let frame = 0;
      let measuredWidth = track.clientWidth;
      let priorityImage = gallery.querySelector('[data-gallery-slide] img[fetchpriority="high"]');
      let opener;
      const update = () => {
        find('[data-gallery-current]').textContent = String(current + 1);
        thumbs.forEach((thumb, i) => { if (i === current) thumb.setAttribute('aria-current','true'); else thumb.removeAttribute('aria-current'); });
        slides.forEach((slide, i) => { slide.querySelector('[data-gallery-open]').tabIndex = i === current ? 0 : -1; });
        if (find('[data-gallery-previous]')) find('[data-gallery-previous]').disabled = current === 0;
        if (find('[data-gallery-next]')) find('[data-gallery-next]').disabled = current === slides.length - 1;
        const thumb = thumbs[current];
        if (thumb) { const strip = find('[data-gallery-thumbs]'); strip.scrollTo({left:thumb.offsetLeft - strip.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2, behavior:'instant'}); }
      };
      const move = (index, instant = false) => {
        if (!Number.isFinite(index)) return;
        cancelAnimationFrame(frame);
        current = Math.max(0, Math.min(slides.length - 1, index));
        if (track.clientWidth > 0) {
          const image = slides[current].querySelector('img');
          if (priorityImage && priorityImage !== image) priorityImage.setAttribute('fetchpriority', 'auto');
          if (image) {
            image.setAttribute('loading', 'eager');
            image.setAttribute('fetchpriority', 'high');
          }
          priorityImage = image;
          measuredWidth = track.clientWidth;
          track.scrollTo({left:current * measuredWidth, behavior:instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }
        update();
      };
      const renderDialog = () => {
        const target = slides[dialogIndex].querySelector('[data-gallery-open]');
        const content = findDialog('[data-dialog-content]');
        if (target.hasAttribute('href')) { const img = new Image(); img.src = target.href; img.alt = target.querySelector('img').alt; img.width = 2000; img.height = 2000; content.replaceChildren(img); }
        else content.replaceChildren(target.querySelector('[data-size-content]').cloneNode(true));
        findDialog('[data-dialog-count]').textContent = `${dialogIndex + 1} / ${slides.length}`;
        findDialog('[data-dialog-previous]').disabled = dialogIndex === 0;
        findDialog('[data-dialog-next]').disabled = dialogIndex === slides.length - 1;
      };
      const open = (index) => {
        if (typeof dialog.showModal !== 'function') return false;
        dialogIndex = index;
        renderDialog();
        if (dialog.open) return true;
        opener = document.activeElement;
        try { dialog.showModal(); } catch (error) { return false; }
        lockScroll(dialog);
        findDialog('[data-dialog-close]').focus({preventScroll:true});
        return true;
      };
      thumbs.forEach((button,i) => button.addEventListener('click', () => move(i)));
      slides.forEach((slide,i) => slide.querySelector('[data-gallery-open]').addEventListener('click', (event) => { if (open(i)) event.preventDefault(); }));
      find('[data-gallery-previous]')?.addEventListener('click', () => move(current - 1));
      find('[data-gallery-next]')?.addEventListener('click', () => move(current + 1));
      track.addEventListener('scroll', () => { if (track.clientWidth <= 0 || track.clientWidth !== measuredWidth) return; cancelAnimationFrame(frame); frame = requestAnimationFrame(() => { if (track.clientWidth <= 0 || track.clientWidth !== measuredWidth) return; current = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / measuredWidth))); update(); }); }, {passive:true});
      track.addEventListener('keydown', (event) => { if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return; event.preventDefault(); move(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1)); });
      findDialog('[data-dialog-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        if (dialog.open) return; // A queued native close event can follow a reopen.
        releaseScroll(dialog);
        if (openDialogs.size === 0 && opener?.isConnected) opener.focus({preventScroll:true});
      });
      dialog.addEventListener('click', (event) => { if(event.target !== dialog) return; const rect = dialog.getBoundingClientRect(); if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); });
      const nextDialog = (delta) => { dialogIndex = Math.max(0,Math.min(slides.length - 1,dialogIndex + delta)); renderDialog(); move(dialogIndex,true); };
      findDialog('[data-dialog-previous]').addEventListener('click', () => nextDialog(-1));
      findDialog('[data-dialog-next]').addEventListener('click', () => nextDialog(1));
      dialog.addEventListener('keydown', (event) => { if(event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); nextDialog(event.key === 'ArrowRight' ? 1 : -1); } });
      gallery.addEventListener('pictomini:compare-sizes', () => { const index = slides.findIndex(s => s.hasAttribute('data-size-slide')); if(index >= 0) open(index); });
      const showFinish = (finish) => { const index = slides.findIndex(slide => slide.dataset.galleryFinish === finish); if (index >= 0) move(index, true); };
      gallery.addEventListener('pictomini:finish-change', event => showFinish(event.detail.finish));
      gallery.addEventListener('pictomini:gallery-start', () => move(0, true));
      const observer = new ResizeObserver(() => { if (track.clientWidth > 0) move(current,true); });
      observer.observe(track);
      const unload = (event) => {
        if (!event.target.contains(gallery)) return;
        observer.disconnect();
        cancelAnimationFrame(frame);
        opener = null;
        if (dialog.open) dialog.close();
        releaseScroll(dialog);
        dialog.remove();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      update();
      // Keep the merchant's first image on entry; finish changes remain interactive.
    });
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pictomini-localization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', event => {
    const disclosure = event.target;
    if (!(disclosure instanceof HTMLDetailsElement) || !disclosure.matches('.pm-localization__disclosure') || !disclosure.open) return;
    document.querySelectorAll('.pm-localization__disclosure[open]').forEach(other => {
      if (other !== disclosure) other.open = false;
    });
  }, true);
  document.addEventListener('pointerdown', event => {
    document.querySelectorAll('.pm-localization__disclosure[open]').forEach(disclosure => {
      if (!disclosure.contains(event.target)) disclosure.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.pm-localization__disclosure[open]').forEach(disclosure => {
      const hadFocus = disclosure.contains(document.activeElement);
      disclosure.open = false;
      if (hadFocus) disclosure.querySelector('summary')?.focus();
    });
  });
  (() => {
    if (window.pmLocalizationPhotoGuard) return;
    window.pmLocalizationPhotoGuard = true;
    document.addEventListener('submit', event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.classList.contains('pm-localization__form') || event.defaultPrevented) return;
      const hasFiles = Array.from(document.querySelectorAll('input[type="file"]')).some(input => input.files && input.files.length > 0);
      const hasBuilderPhotos = !!document.querySelector('[data-photo-list] li, [data-drop][data-has-photos="true"]');
      if (!hasFiles && !hasBuilderPhotos) return;
      if (!form.dataset.photoNotice || !window.confirm(form.dataset.photoNotice)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  })();
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('pm-localization__form')) return;
    const returnTo = form.querySelector('input[name="return_to"]');
    if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pictomini-model-showcase"] && !Shopify.designMode) return;
  try {
    (() => {
    const runtime = window.PictoMiniModelRuntime ||= { promise: null };
    const loadRuntime = (url) => {
      if (customElements.get('model-viewer')) return Promise.resolve();
      if (!runtime.promise) {
        runtime.promise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.type = 'module';
          script.src = url;
          script.dataset.pmModelRuntime = 'true';
          script.addEventListener('load', () => {
            if (customElements.get('model-viewer')) resolve();
            else { script.remove(); reject(new Error('Model viewer unavailable')); }
          }, { once: true });
          script.addEventListener('error', () => { script.remove(); reject(new Error('Model viewer unavailable')); }, { once: true });
          document.head.append(script);
        }).catch((error) => { runtime.promise = null; throw error; });
      }
      return runtime.promise;
    };
    const pendingCards = new WeakMap();
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) pendingCards.get(entry.target)?.load(); });
    }, { rootMargin: '300px 0px' }) : null;
    const initialize = (root = document) => root.querySelectorAll('[data-model-showcase]:not([data-model-initialized])').forEach((card) => {
      card.dataset.modelInitialized = 'true';
      const viewer = card.querySelector('[data-model-viewer]');
      if (!viewer) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) viewer.removeAttribute('auto-rotate');
      const ready = () => { card.dataset.ready = 'true'; };
      viewer.addEventListener('load', ready, { once: true });
      if (viewer.loaded) ready();
      let loading = false;
      let loaded = false;
      const load = () => {
        if (loading || loaded || !card.isConnected) return;
        loading = true;
        loadRuntime(card.dataset.modelModuleUrl).then(() => {
          loaded = true;
          observer?.unobserve(card);
        }).catch(() => {}).finally(() => { loading = false; });
      };
      const interact = () => {
        const bounds = card.getBoundingClientRect();
        if (bounds.width > 0 && bounds.height > 0 && bounds.bottom > 0 && bounds.top < innerHeight) load();
      };
      card.addEventListener('pointerdown', interact, { passive: true });
      card.addEventListener('focusin', interact);
      pendingCards.set(card, { load, cleanup: () => {
        observer?.unobserve(card);
        card.removeEventListener('pointerdown', interact);
        card.removeEventListener('focusin', interact);
        viewer.removeEventListener('load', ready);
        pendingCards.delete(card);
        delete card.dataset.modelInitialized;
      } });
      if (observer) observer.observe(card);
      else load();
    });
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-model-showcase]').forEach((card) => pendingCards.get(card)?.cleanup());
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pictomini-photo-viewer"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-photo-viewer]');
    if (!dialog || dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    const image = dialog.querySelector('[data-photo-viewer-image]');
    const status = dialog.querySelector('[data-photo-viewer-status]');
    const previous = dialog.querySelector('[data-photo-viewer-previous]');
    const next = dialog.querySelector('[data-photo-viewer-next]');
    let photos = [], index = 0, returnFocus = null, startX = null;
    const safe = (value) => {
      try { const url = new URL(value, location.origin); return url.protocol === 'blob:' && url.origin === location.origin || url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' && url.pathname.includes('/uploads/'); }
      catch { return false; }
    };
    const display = () => {
      status.hidden = false;
      status.textContent = status.dataset.loading;
      image.alt = photos[index].label;
      image.src = photos[index].url;
      dialog.querySelector('[data-photo-viewer-caption]').textContent = `${photos[index].label} · ${index + 1} / ${photos.length}`;
      previous.disabled = index === 0;
      next.disabled = index === photos.length - 1;
    };
    image.addEventListener('load', () => { status.hidden = true; });
    image.addEventListener('error', () => { if (dialog.open) { status.hidden = false; status.textContent = status.dataset.error; } });
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-photo-preview]');
      if (!trigger || !safe(trigger.dataset.photoPreview)) return;
      event.preventDefault();
      const group = trigger.closest('[data-cart-drawer-line], .pm-cart-item, [data-photo-list], [data-review-photos], [data-v1-photo-preview]') || trigger.parentElement;
      photos = [];
      group.querySelectorAll('[data-photo-preview]').forEach((node) => {
        const url = node.dataset.photoPreview;
        if (safe(url) && !photos.some((photo) => photo.url === url)) photos.push({ url, label: node.dataset.photoLabel || node.querySelector('img')?.alt || dialog.querySelector('h2').textContent });
      });
      index = Math.max(0, photos.findIndex((photo) => photo.url === trigger.dataset.photoPreview));
      returnFocus = trigger;
      if (!photos.length) return;
      if (!dialog.open) dialog.showModal();
      display();
      dialog.querySelector('[data-photo-viewer-close]').focus({ preventScroll: true });
    });
    previous.addEventListener('click', () => { if (index > 0) { index--; display(); } });
    next.addEventListener('click', () => { if (index < photos.length - 1) { index++; display(); } });
    dialog.querySelector('[data-photo-viewer-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); dialog.close(); }
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); (event.key === 'ArrowLeft' ? previous : next).click(); }
    });
    const stage = dialog.querySelector('[data-photo-viewer-stage]');
    stage.addEventListener('pointerdown', (event) => { startX = event.isPrimary ? event.clientX : null; });
    stage.addEventListener('pointerup', (event) => { if (startX !== null && Math.abs(event.clientX - startX) > 50) (event.clientX < startX ? next : previous).click(); startX = null; });
    stage.addEventListener('pointercancel', () => { startX = null; });
    dialog.addEventListener('close', () => { image.removeAttribute('src'); image.alt = ''; photos = []; if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true }); returnFocus = null; });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pictomini-upsell"] && !Shopify.designMode) return;
  try {
    (() => {

    if (window.PictoMiniUpsell) return;

    const storageKey = 'pictomini:optional-extras:v1';

    const miniHandles = new Set(['custom-chibi-figure-from-photo', 'custom-best-friend-chibi-figures-from-photos', 'custom-couple-chibi-figures-from-photos', 'custom-wedding-chibi-figures-from-photos', 'custom-person-pet-chibi-figures-from-photos', 'custom-family-portrait-chibi-figures-from-photos']);

    const attempts = new Map();

    const busy = new Map();

    const lockedControls = new Map();

    const lockedLinks = new Map();

    let cartMutationBusy = false;

    let storageReady = true;

    let cartSnapshot = null;

    let syncSequence = 0;

    let syncTimer;

    let syncInFlight = null;

    let syncFlightSequence = 0;

    const root = () => window.Shopify?.routes?.root || '/';

    const cards = () => Array.from(document.querySelectorAll('[data-upsell-card]'));

    const strings = (card) => {

      try { return JSON.parse(card.closest('[data-pm-upsell]').querySelector('[data-upsell-strings]').textContent); } catch { return {}; }

    };

    const save = () => {

      try { sessionStorage.setItem(storageKey, JSON.stringify(Object.fromEntries(attempts))); return true; }

      catch { storageReady = false; return false; }

    };

    try {

      const raw = sessionStorage.getItem(storageKey);

      const entries = raw ? JSON.parse(raw) : {};

      if (!entries || Array.isArray(entries) || typeof entries !== 'object') throw new Error('invalid-storage');

      for (const [id, attempt] of Object.entries(entries)) {

        if (!/^\d+$/.test(id) || !attempt || !/^[a-zA-Z0-9-]{10,100}$/.test(attempt.token) || !/^\d+$/.test(String(attempt.variantId)) || !['pending', 'confirmed', 'rejected'].includes(attempt.state)) throw new Error('invalid-attempt');

        attempts.set(id, {token: attempt.token, variantId: String(attempt.variantId), productId: id, state: attempt.state, createdAt: Number(attempt.createdAt) || 0});

      }

      save();

    } catch { storageReady = false; }

    const validCart = (cart) => cart && Array.isArray(cart.items) && Number.isSafeInteger(cart.item_count) && cart.item_count >= 0;

    const productPresent = (cart, id) => cart.items.some((item) => String(item.product_id) === String(id) && Number(item.quantity) > 0);

    const miniPresent = (cart) => cart.items.some((item) => miniHandles.has(item.handle) && Number(item.quantity) > 0);

    const targetPresent = (cart, card) => {

      let targets;

      try { targets = JSON.parse(card.dataset.upsellTargets || '[]'); } catch { return false; }

      if (!Array.isArray(targets)) return false;

      if (!targets.length) return true;

      if (card.closest('[data-pm-upsell]').dataset.upsellPlacement === 'product' && card.dataset.upsellRequiresMini !== 'true') return true;

      return cart.items.some((item) => targets.some((id) => String(id) === String(item.product_id)) && Number(item.quantity) > 0);

    };

    const lockControls = () => {

      const nodes = Array.from(document.querySelectorAll('[data-cart-change], [data-cart-drawer] [name="checkout"], .pm-cart-form input[name="updates[]"], [data-v2-builder][data-step="2"] [data-next], button, input[type="submit"]')).filter((node) => node.matches('[data-cart-change], [data-cart-drawer] [name="checkout"], .pm-cart-form input[name="updates[]"], [data-v2-builder][data-step="2"] [data-next]') || node.form?.matches('.pm-cart-form'));

      nodes.forEach((node) => { if (!lockedControls.has(node)) lockedControls.set(node, node.disabled); node.disabled = true; });

      document.querySelectorAll('.pm-cart-item__remove, [data-cart-drawer] [data-cart-remove]').forEach((node) => { if (!lockedLinks.has(node)) lockedLinks.set(node, node.getAttribute('aria-disabled')); node.setAttribute('aria-disabled', 'true'); });

    };

    const releaseControls = () => {

      lockedControls.forEach((disabled, node) => { if (node.isConnected) node.disabled = disabled; }); lockedControls.clear();

      lockedLinks.forEach((value, node) => { if (!node.isConnected) return; if (value === null) node.removeAttribute('aria-disabled'); else node.setAttribute('aria-disabled', value); }); lockedLinks.clear();

    };

    const receiptPresent = (items, attempt) => items.some((item) => String(item.variant_id || item.id) === attempt.variantId && Number(item.quantity) > 0 && item.properties?._pictomini_upsell_attempt === attempt.token);

    const status = (card, message) => { const node = card.querySelector('[data-upsell-status]'); if (node) node.textContent = message || ''; };

    const updateCounts = (cart) => {

      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = String(cart.item_count); });

      document.querySelectorAll('[data-cart-count-badge]').forEach((node) => { node.textContent = String(cart.item_count); node.hidden = cart.item_count === 0; });

      const drawer = document.querySelector('[data-cart-drawer]');

      if (drawer?.dataset.cartDrawerLabel) document.querySelectorAll('[data-cart-drawer-toggle]').forEach((node) => node.setAttribute('aria-label', drawer.dataset.cartDrawerLabel + ' (' + cart.item_count + ')'));

    };

    const render = () => {

      cards().forEach((card) => {

        const id = card.dataset.upsellProductId;

        if (cartSnapshot && productPresent(cartSnapshot, id)) { card.hidden = true; return; }

        card.hidden = false;

        if (card.dataset.upsellAction !== 'add') return;

        const copy = strings(card), add = card.querySelector('[data-upsell-add]'), select = card.querySelector('[data-upsell-variant]'), attempt = attempts.get(id);

        const pending = attempt?.state === 'pending', confirmed = attempt?.state === 'confirmed';

        const hasMini = cartSnapshot ? miniPresent(cartSnapshot) : card.closest('[data-pm-upsell]').dataset.upsellHasMini === 'true';

        card.querySelector('[data-upsell-quick]').hidden = !storageReady;

        card.querySelector('[data-upsell-fallback]').hidden = false;

        if (!storageReady) { status(card, copy.storageUnavailable); return; }

        if (pending && Array.from(select.options).some((option) => option.value === attempt.variantId)) select.value = attempt.variantId;

        const mode = busy.get(id);

        const needsMini = card.dataset.upsellRequiresMini === 'true' && !hasMini;

        add.disabled = cartMutationBusy || busy.size > 0 || pending || confirmed || needsMini || !select.value;

        select.disabled = cartMutationBusy || busy.size > 0 || pending || confirmed;

        add.textContent = mode === 'adding' ? copy.adding : mode === 'checking' ? copy.checking : add.dataset.label || copy.add;

        const check = card.querySelector('[data-upsell-check]');

        check.hidden = !pending && !confirmed;

        check.disabled = cartMutationBusy || busy.size > 0;

        check.textContent = copy.checkCart;

        card.querySelector('[data-upsell-cart-link]').hidden = !pending && !confirmed;

        card.setAttribute('aria-busy', mode ? 'true' : 'false');

        if (pending && mode) status(card, mode === 'adding' ? copy.adding : copy.checking);

        else if (pending && !card.dataset.upsellKeepStatus) status(card, copy.uncertain);

        else if (confirmed) status(card, copy.added);

        else if (!pending && needsMini) status(card, copy.miniFirst);

        else if (!mode && !card.dataset.upsellKeepStatus) status(card, '');

        const option = select.selectedOptions[0];

        if (option?.dataset.price) card.querySelector('[data-upsell-price]').textContent = option.dataset.price;

      });

      document.querySelectorAll('[data-pm-upsell]').forEach((group) => {

        group.hidden = !Array.from(group.querySelectorAll('[data-upsell-card]')).some((card) => !card.hidden) && group.querySelector('[data-upsell-notice]').hidden;

      });

      if (cartMutationBusy) lockControls();

    };

    const applyCart = (cart) => {

      if (!validCart(cart)) throw new Error('invalid-cart');

      syncSequence += 1;

      cartSnapshot = cart;

      let changed = false;

      attempts.forEach((attempt, id) => {

        if (attempt.state === 'pending' && receiptPresent(cart.items, attempt)) { attempt.state = 'confirmed'; changed = true; }

        else if (attempt.state === 'confirmed' && !productPresent(cart, id)) { attempts.delete(id); changed = true; }

      });

      if (changed) save();

      updateCounts(cart);

      render();

    };

    const readCart = async () => {

      const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 12000);

      try {

        const response = await fetch(root() + 'cart.js', {credentials: 'same-origin', headers: {Accept: 'application/json'}, cache: 'no-store', signal: controller.signal});

        if (!response.ok) throw new Error('cart-read-' + response.status);

        const cart = await response.json();

        if (!validCart(cart)) throw new Error('invalid-cart');

        return cart;

      } finally { clearTimeout(timer); }

    };

    const announce = (group, message) => {

      if (!group?.isConnected) return;

      const notice = group.querySelector('[data-upsell-notice]');

      notice.textContent = message;

      notice.hidden = false;

      group.hidden = false;

      const link = document.createElement('a');

      link.href = root() + 'cart';

      link.className = 'pm-upsell__details';

      try { link.textContent = JSON.parse(group.querySelector('[data-upsell-strings]').textContent).viewCart; } catch { return; }

      notice.append(document.createTextNode(' '), link);

    };

    const refreshAfterAdd = async (card, sections, cart) => {

      const group = card.closest('[data-pm-upsell]'), copy = strings(card), placement = group.dataset.upsellPlacement;

      const returnFocus = card.contains(document.activeElement);

      announce(group, copy.added);

      if (cart) applyCart(cart);

      let refreshed = false;

      try {

        if (placement === 'cart_page') { location.reload(); return; }

        if (!window.PictoMiniCart?.refresh) throw new Error('drawer-unavailable');

        await window.PictoMiniCart.refresh(sections, cart);

        refreshed = true;

      } catch { announce(group, copy.addedRefreshFailed); }

      if (!cart) {

        try { await sync(); }

        catch { if (!refreshed) announce(group, copy.addedRefreshFailed); }

      }

      render();

      if (returnFocus) {

        const notice = group.isConnected ? group.querySelector('[data-upsell-notice]:not([hidden])') : null;

        (notice || document.querySelector('[data-cart-drawer][open] [data-cart-drawer-close]'))?.focus({preventScroll: true});

      }

    };

    const sync = (cart) => {

      clearTimeout(syncTimer);

      if (validCart(cart)) { applyCart(cart); return Promise.resolve(); }

      if (syncInFlight && syncFlightSequence === syncSequence) return syncInFlight;

      const sequence = ++syncSequence;

      syncFlightSequence = sequence;

      syncInFlight = (async () => {

        try { const latest = await readCart(); if (sequence === syncSequence) applyCart(latest); }

        catch { render(); }

        finally { if (syncFlightSequence === sequence) syncInFlight = null; }

      })();

      return syncInFlight;

    };

    const checkCart = async (card) => {

      const id = card.dataset.upsellProductId;

      if (busy.size || cartMutationBusy) return;

      const copy = strings(card), attempt = attempts.get(id);

      delete card.dataset.upsellKeepStatus;

      busy.set(id, 'checking'); render();

      try {

        const cart = await readCart();

        const confirmed = attempt && receiptPresent(cart.items, attempt);

        applyCart(cart);

        if (confirmed) await refreshAfterAdd(card, null, cart);

        else if (productPresent(cart, id)) announce(card.closest('[data-pm-upsell]'), copy.alreadyInCart);

        else { card.dataset.upsellKeepStatus = 'true'; status(card, copy.stillChecking); }

      } catch { card.dataset.upsellKeepStatus = 'true'; status(card, copy.cartUnavailable); }

      finally { busy.delete(id); render(); }

    };

    const add = async (card) => {

      const id = card.dataset.upsellProductId, prior = attempts.get(id), copy = strings(card);

      if (window.PictoMiniAddons?.isBusy() || !storageReady || cartMutationBusy || busy.size || prior?.state === 'pending' || prior?.state === 'confirmed' || card.dataset.upsellAction !== 'add') return;

      if (document.querySelector('[data-cart-drawer].is-busy, [data-v2-builder][aria-busy="true"]')) { card.dataset.upsellKeepStatus = 'true'; status(card, copy.checking); return; }

      const selected = card.querySelector('[data-upsell-variant]').selectedOptions[0];

      if (!selected || !/^\d+$/.test(selected.value)) { status(card, copy.unavailable); return; }

      const fullCart = card.closest('[data-pm-upsell]').dataset.upsellPlacement === 'cart_page';

      const cartForm = fullCart ? document.querySelector('.pm-cart-form') : null;

      const quantityInputs = cartForm ? Array.from(cartForm.querySelectorAll('input[name="updates[]"]')) : [];

      if (quantityInputs.some((input) => input.value !== input.defaultValue)) { card.dataset.upsellKeepStatus = 'true'; status(card, copy.updateCartFirst); return; }

      cartMutationBusy = true;

      const variantId = selected.value;

      busy.set(id, 'checking'); delete card.dataset.upsellKeepStatus; render();

      let attempt = null;

      try {

        const cart = await readCart();

        applyCart(cart);

        if (productPresent(cart, id)) { announce(card.closest('[data-pm-upsell]'), copy.alreadyInCart); return; }

        if (card.dataset.upsellRequiresMini === 'true' && !miniPresent(cart)) { status(card, copy.miniFirst); return; }

        if (!targetPresent(cart, card)) { card.dataset.upsellKeepStatus = 'true'; status(card, copy.miniFirst); return; }

        if (!window.crypto?.randomUUID) { storageReady = false; return; }

        attempt = {token: crypto.randomUUID(), variantId, productId: id, state: 'pending', createdAt: Date.now()};

        attempts.set(id, attempt);

        if (!save()) return;

        busy.set(id, 'adding'); render();

        const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 18000);

        let response, data;

        try {

          response = await fetch(root() + 'cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {Accept: 'application/json', 'Content-Type': 'application/json'}, signal: controller.signal, body: JSON.stringify({items: [{id: Number(variantId), quantity: 1, properties: {_pictomini_upsell_attempt: attempt.token}}], sections: ['pictomini-cart-drawer'], sections_url: location.pathname + location.search})});

          data = await response.json();

        } finally { clearTimeout(timer); }

        const receipt = Array.isArray(data?.items) ? data.items : data ? [data] : [];

        if (response.ok && receiptPresent(receipt, attempt)) {

          attempt.state = 'confirmed'; syncSequence += 1; save();

          await refreshAfterAdd(card, data.sections);

        } else if (response.status === 422 && Number(data?.status) === 422 && (typeof data?.description === 'string' || typeof data?.message === 'string')) {

          attempt.state = 'rejected'; save();

          card.dataset.upsellKeepStatus = 'true'; status(card, copy.rejected);

        } else {

          card.dataset.upsellKeepStatus = 'true'; status(card, copy.uncertain);

        }

      } catch {

        card.dataset.upsellKeepStatus = 'true';

        status(card, attempt ? copy.uncertain : copy.cartUnavailable);

      } finally { cartMutationBusy = false; releaseControls(); busy.delete(id); render(); }

    };

    document.addEventListener('click', (event) => {

      if (!cartMutationBusy) return;

      const control = event.target.closest('[data-cart-change], [data-cart-remove], .pm-cart-item__remove, [data-cart-drawer] [name="checkout"], .pm-cart-form button, [data-v2-builder][data-step="2"] [data-next], button[form], input[type="submit"][form]');

      if (!control) return;

      if (control.matches('button[form],input[type="submit"][form]') && !control.form?.matches('.pm-cart-form')) return;

      event.preventDefault(); event.stopImmediatePropagation();

    }, true);

    document.addEventListener('submit', (event) => {

      if (cartMutationBusy && event.target.matches('.pm-cart-form, [data-cart-drawer] form')) { event.preventDefault(); event.stopImmediatePropagation(); }

    }, true);

    document.addEventListener('click', (event) => {

      const check = event.target.closest('[data-upsell-check]');

      if (check) { event.preventDefault(); checkCart(check.closest('[data-upsell-card]')); return; }

      const button = event.target.closest('[data-upsell-add]');

      if (button) { event.preventDefault(); add(button.closest('[data-upsell-card]')); }

    });

    document.addEventListener('change', (event) => {

      const select = event.target.closest('[data-upsell-variant]');

      if (!select) return;

      const card = select.closest('[data-upsell-card]');

      delete card.dataset.upsellKeepStatus; render();

    });

    const observer = new MutationObserver((mutations) => {

      let newCards = false, cartReplaced = false;

      mutations.forEach((mutation) => Array.from(mutation.addedNodes).forEach((node) => {

        if (node.nodeType !== 1) return;

        if (node.matches('[data-pm-upsell]') || node.querySelector('[data-pm-upsell]')) newCards = true;

        if (node.matches('[data-cart-drawer-content]') || node.querySelector('[data-cart-drawer-content]')) cartReplaced = true;

      }));

      if (newCards) render();

      // The drawer publishes cart-updated after replacement; its event owns synchronization.

      if (cartReplaced && !window.PictoMiniCart?.refresh) { clearTimeout(syncTimer); syncTimer = setTimeout(sync, 80); }

    });

    observer.observe(document.documentElement, {childList: true, subtree: true});

    document.addEventListener('shopify:section:load', () => { render(); sync(); });

    document.addEventListener('pictomini:cart-updated', (event) => sync(event.detail?.cart));

    window.PictoMiniUpsell = {sync, isBusy: () => cartMutationBusy};

    render();

    if (document.querySelector('[data-pm-upsell]')) sync();

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pictomini-ux-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    const watchConsent = () => {
      const banner = document.getElementById('shopify-pc__banner');
      const open = !!banner && banner.offsetParent !== null && getComputedStyle(banner).visibility !== 'hidden';
      root.classList.toggle('pm-consent-open', open);
    };
    new MutationObserver(watchConsent).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
    watchConsent();

    const bar = document.querySelector('[data-pm-sticky-cta]');
    const builder = document.querySelector('[data-v2-builder]');
    if (!bar || !builder) return;
    const mobile = matchMedia('(max-width: 760px)');
    let builderVisible = true;
    const sync = () => {
      const show = mobile.matches && !builderVisible && !root.classList.contains('pm-cart-drawer-open');
      bar.hidden = !show;
      root.classList.toggle('pm-sticky-on', show);
      const price = builder.querySelector('[data-heading-price]') || builder.querySelector('[data-price]');
      if (price && price.textContent.trim()) bar.querySelector('[data-pm-sticky-price]').textContent = price.textContent.trim();
    };
    // Watch the builder's own action area, not the whole section (which also holds the gallery).
    const actionArea = builder.querySelector('[data-next]') || builder;
    const check = () => { const rect = actionArea.getBoundingClientRect(); builderVisible = rect.bottom > 0 && rect.top < window.innerHeight; sync(); };
    let queued = false;
    const queue = () => { if (queued) return; queued = true; setTimeout(() => { queued = false; check(); }, 120); };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    check();
    new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'] });
    mobile.addEventListener('change', sync);
    document.addEventListener('pictomini:builder-updated', sync);
    bar.querySelector('[data-pm-sticky-go]').addEventListener('click', () => {
      const heading = builder.querySelector('[data-step-heading]');
      const target = (heading && heading.closest('fieldset')) || builder;
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      if (heading) setTimeout(() => heading.focus({ preventScroll: true }), 400);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
